import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction} from 'react'
import {Col, Modal, Row} from 'react-bootstrap'
import {KTCard, KTCardBody, KTSVG} from '../../../../../../../_metronic/helpers'
import {CheckingModel} from '../../../../lavanderia/model'
import {downloadPDFCheckInOutService} from '../../../services/booking.service'
import moment from 'moment'
import {getSnackBarToast} from '../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  checkin: CheckingModel | null
  getChekings: () => void
}

const ModalCheckoutApp: FC<Props> = ({show, setShow, checkin, getChekings}) => {
  const handleClose = () => {
    setShow(false)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const handleDownload = async () => {
    try {
      let dto = {
        reservaCamaId: checkin?.ReservaCamaId,
        tipo: 'OUT',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckOut-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getChekings()
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Datos de Checkout</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <KTCard className='shadow-sm m-2'>
            <h4 className='d-flex align-items-center ps-6 pt-6 pe-6'>
              Codigo de Reserva : {`${checkin?.CodigoReserva}`}
            </h4>
            <KTCardBody>
              <Row>
                <h5 className='text-success'>Checkout Realizado</h5>
              </Row>
              <Row>
                <Col>
                  <strong>Fecha/hora checkin: </strong>
                </Col>
                <Col>
                  <span>{checkin?.FechaCheckIn}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Fecha/hora checkout: </strong>
                </Col>
                <Col>
                  <span>{checkin?.FechaCheckOut}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Fecha ingreso programada: </strong>
                </Col>
                <Col>
                  <span>{checkin?.FechaInicio}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Fecha salida programada: </strong>
                </Col>
                <Col>
                  <span>{checkin?.FechaFin}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Site: </strong>
                </Col>
                <Col>
                  <span>{checkin?.Site}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Campamento: </strong>
                </Col>
                <Col>
                  <span>{checkin?.Campamento}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Módulo: </strong>
                </Col>
                <Col>
                  <span>{checkin?.Modulo}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Habitación: </strong>
                </Col>
                <Col>
                  <span>{checkin?.Habitacion}</span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <strong>Cama: </strong>
                </Col>
                <Col>
                  <span>{checkin?.CodigoCama}</span>
                </Col>
              </Row>
            </KTCardBody>
          </KTCard>
          <div className='d-flex justify-content-center mb-3'>
            <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
              Cancelar
            </button>
            <button type='button' className='btn btn-primary' onClick={handleDownload}>
              Descargar Ticket Checkout
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalCheckoutApp}
